"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _line = require("@nivo/line");

var _index = require("../../../../utils/index");

var _linechart_helpers = _interopRequireDefault(require("../linechart_helpers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// https://nivo.rocks/line/
// utils

/* ========== ~~~~~~~~~~ EXPORT : CHART : LINE : OVERVIEW ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  var handleCustomTooltip = function handleCustomTooltip(dataSlice) {
    var date = new Date(dataSlice.point.data.x);
    return _react.default.createElement("div", {
      style: {
        color: '#bbb'
      }
    }, _react.default.createElement("div", {
      style: {
        background: '#FFFFFF',
        border: '1px solid rgb(236, 240, 247)',
        borderRadius: '3px',
        color: '#062B75',
        padding: '8px 5px',
        display: 'flex',
        flexDirection: 'row'
      }
    }, _react.default.createElement("div", {
      style: {
        marginRight: '10px'
      }
    }, _index.abbreviatedMonths[date.getMonth()], " ", date.getDate()), " ", _react.default.createElement("strong", null, (0, _linechart_helpers.default)(dataSlice.point.data.y, props.yType))));
  };

  var dateLength = !!props.data[0] ? props.data[0].data.length : null;
  return _react.default.createElement(_line.ResponsiveLine, {
    data: props.data,
    margin: {
      top: 10,
      right: 35,
      bottom: 50,
      left: 60
    },
    xScale: {
      type: 'time',
      format: '%Y-%m-%d',
      precision: 'day',
      useUTC: false
    },
    yScale: {
      "type": "linear",
      "stacked": true,
      "min": 0,
      "max": "auto"
    },
    axisBottom: {
      orient: 'bottom',
      tickSize: 0,
      tickPadding: 20,
      tickRotation: 0,
      format: '%b %d',
      tickValues: dateLength <= 5 ? dateLength : 5
    },
    axisLeft: {
      orient: 'left',
      tickSize: 0,
      tickPadding: 20,
      tickRotation: 0,
      legend: '',
      legendOffset: -40,
      legendPosition: 'middle'
    },
    tooltip: function tooltip(slice) {
      return handleCustomTooltip(slice);
    },
    enableGridX: false,
    enableGridY: true,
    colors: function colors(d) {
      return d.color;
    },
    lineWidth: 2,
    enablePoints: false,
    enableArea: true,
    areaOpacity: 0.3,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
    useMesh: true,
    enableCrosshair: true,
    crosshairType: 'bottom-left',
    theme: {
      crosshair: {
        line: {
          stroke: 'rgb(20, 148, 244)',
          strokeWidth: 2,
          strokeOpacity: 1
        }
      }
    }
  });
};

exports.default = _default;